'use strict'

import Vue from 'vue'
import VueRouter from 'vue-router'
import VueMeta from 'vue-meta'
import { VIEWS } from '@/views/names'
import Login from '@/views/login/Login'
import Table from '@/views/table/Table'
import TableSettings from '@/views/table/settings/TableSettings'
import TableQueue from '@/views/table/queue/TableQueue'
import DoubleStatusTableQueue from '@/components/table/custom-table/DoubleStatusTableQueue.vue'
import RaifTableQueue from '@/components/table/custom-table/RaifTableQueue'
import Cookies from 'js-cookie'
import store from '@/store/store'

Vue.use(VueRouter)
Vue.use(VueMeta)

const router = new VueRouter({
  routes: [
    {
      path: '/',
      name: VIEWS.login.name,
      component: Login
    },
    {
      path: '/table',
      name: VIEWS.table.index.name,
      component: Table,
      meta: { requiresAuth: true },
      children: [
        {
          path: 'settings',
          name: VIEWS.table.settings.name,
          component: TableSettings
        },
        {
          path: 'queue',
          name: VIEWS.table.queue.name,
          component: TableQueue,
          meta: { hasSettings: true }
        },
        {
          path: 'custom/raif/queue',
          name: VIEWS.table.custom.raif.queue.name,
          component: RaifTableQueue,
          meta: { hasSettings: true }
        },
        {
          path: 'custom/double-status/queue',
          name: VIEWS.table.custom.doubleStatus.name,
          component: DoubleStatusTableQueue,
          meta: { hasSettings: true }
        }
      ]
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.name === VIEWS.login.name) {
    if (to.query.id && to.query.key) {
      next()
    } else if (Cookies.get('userData')) {
      next({
        name: VIEWS.table.settings.name
      })
    }
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!Cookies.get('userData')) {
      next({
        path: '/'
      })
    } else {
      if (to.matched.some(record => record.meta.hasSettings)) {
        if (!store.state.gui.settings.tryInit) {
          next({
            name: VIEWS.table.settings.name
          })
        } else {
          next()
        }
      } else {
        next()
      }
    }
  } else {
    next()
  }
})

export default router
